// Linhas que o sistema grava com nome em português: formas de entrega (Empresa::FORMAS_ENTREGA) e as formas
// de pagamento 1 a 4, que o lojista não consegue renomear (INTERNACIONALIZACAO_EUA_PLAN.md §4.4).
// A lógica compara pelo id; a tela traduz pelo id com tSistema('sistema.formaPagamento.' + id, descricao).
// O nome continua valendo junto com o id, como sempre valeu.

export const ENTREGA_RETIRADA = 1;
export const ENTREGA_DELIVERY = 2;
export const ENTREGA_LOCAL = 3;

export const PAGAMENTO_DINHEIRO = 1;
export const PAGAMENTO_PIX = 3;

export const temFormaEntrega = (configuracoes, id) =>
    (configuracoes?.formas_entrega || []).some(e => +e.id === id);

export const ehDinheiro = formaPagamento =>
    +formaPagamento?.id === PAGAMENTO_DINHEIRO || formaPagamento?.descricao === 'Dinheiro';

export const ehPix = formaPagamento =>
    +formaPagamento?.id === PAGAMENTO_PIX || formaPagamento?.descricao === 'Pix';
